export default "__VITE_PUBLIC_ASSET__a1b86d9f__"